export const extractUserDetails = (user) => {
  return {
    id: user.id,
    email: user.email,
    fullName: user.user_metadata.full_name,
    username: user.user_metadata.user_name,
    role: user.role,
    avatarUrl: extractAvatarUrl(user),
    initials: extractInitials(user),
  }
}
const extractAvatarUrl = (user) => {
  if (user?.user_metadata.avatar_url) {
    return user?.user_metadata.avatar_url
  }
  if (user?.email) {
    return `https://unavatar.io/${user.email}`
  }
  return null
}
const extractInitials = (user) => {
  return (user?.user_metadata?.full_name || '')
    .split(' ')
    .map((n) => n[0])
    .join('')
}

export const extractUserName = (user) => {
  return user.user_metadata.name || user.email
}
